export const updateATSProcessing = `mutation UpdateATSProcessing($input: UpdateATSProcessingInput!) {
    updateATSProcessing(input: $input) {
        id
        status
    }
  }
  `;